import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "hstack gap-1" }
const _hoisted_2 = { key: 0 }

import { defineComponent, watch, ref } from 'vue';
import type { PropType } from 'vue';
import Datepicker from '@vuepic/vue-datepicker';
import {
    BFilter
} from "@/components/BFilterEditor/BFilterEditor.types";


const dateFormat = "yyyy-MM-dd";
        
        
export default /*@__PURE__*/_defineComponent({
  __name: 'DateField',
  props: {
    items: {},
    disabled: { type: Boolean },
    modelValue: {},
    label: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {


const props = __props


        const filterValue = ref(props.modelValue ?? "");
        
       
    


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label != '')
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_unref(Datepicker), {
      "model-value": _ctx.modelValue,
      format: dateFormat,
      "enable-time-picker": false,
      utc: true,
      clearable: true,
      required: true,
      "input-class-name": 'form-control',
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }, null, 8, ["model-value"])
  ]))
}
}

})